var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":("file_uploader_" + _vm.id)}},[_vm._v("\n  ローカルから選択\n  "),_c('input',{staticClass:"input",attrs:{"id":("file_uploader_" + _vm.id),"type":"file"},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }